import { delay, put, takeLatest } from 'typed-redux-saga/macro';
import { getRecommendations } from 'actions';
import { POST_FUNNEL_EVENTS_SUCCESS } from '../actions/types';
import { InvestFunnelChoiceEvents, InvestFunnelEvents, SaveFunnelEvents, } from '../types';
const RECOMMENDATION_EVENTS = new Set([
    ...Object.values(SaveFunnelEvents),
    ...Object.values(InvestFunnelEvents),
    ...Object.values(InvestFunnelChoiceEvents),
]);
// The backend builds the Save/Invest "finish setup" recommendations from these
// events, so refetch them once it has recorded a new step.
function* refreshRecommendationsSaga({ extra }) {
    if (extra.events.some((event) => RECOMMENDATION_EVENTS.has(event))) {
        yield* delay(2000);
        yield* put(getRecommendations());
    }
}
function* funnelEventsSaga() {
    yield* takeLatest(POST_FUNNEL_EVENTS_SUCCESS, refreshRecommendationsSaga);
}
export default funnelEventsSaga;
